export const ENTITIES_ADDED = 'ENTITIES_ADDED';

export function entitiesAdded(resource, entities) {
  return {
    type: ENTITIES_ADDED,
    resource,
    entities
  };
}



// WEBPACK FOOTER //
// ./src/actions/entityActions.js